import { createAction } from '@reduxjs/toolkit';
import {
  BoothLiveStreamingLastTimeStampUpdateActionPayload, BoothLiveStreamingStatusCleanUpActionPayload,
  BoothLiveStreamingStatusUpdateActionPayload,
  LiveStreamJoinActionPayload,
} from 'models/liveStream/types';

const ACTION_PREFIX = 'liveStream';

// eslint-disable-next-line import/prefer-default-export
export const liveStreamActions = {
  joinChannel: createAction<LiveStreamJoinActionPayload<any>>(`${ACTION_PREFIX}/joinChannel`),
  updateIsClosable: createAction<boolean>(`${ACTION_PREFIX}/updateIsClosable`),
  updateBoothLiveStreamingLastTimeStamp: createAction<BoothLiveStreamingLastTimeStampUpdateActionPayload>(`${ACTION_PREFIX}/updateBoothLiveStreamingLastTimeStamp`),
  updateBoothLiveStreamingStatus: createAction<BoothLiveStreamingStatusUpdateActionPayload>(`${ACTION_PREFIX}/updateBoothLiveStreamingStatus`),
  cleanUpBoothLiveStreamingStatus: createAction<BoothLiveStreamingStatusCleanUpActionPayload>(`${ACTION_PREFIX}/cleanUpBoothLiveStreamingStatus`),
};
